document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('[data-nemee-bandeau]');
  if (!root) return;

  var entete = root.querySelector('.nemee-bandeau-entete');
  if (!entete) return;

  var boutonGradees = entete.querySelector('[data-nemee-onglet="gradees"]');
  var boutonUnite = entete.querySelector('[data-nemee-onglet="unite"]');
  var separateur = entete.querySelector('.nemee-bandeau-sep');

  if (boutonGradees && boutonUnite && separateur) {
    entete.insertBefore(boutonUnite, boutonGradees);
    entete.insertBefore(separateur, boutonGradees);
    boutonUnite.click();
  }
});

(function () {
  var STAR_SVG = '<svg viewBox="0 0 200 200" width="44" height="44" xmlns="http://www.w3.org/2000/svg" style="display:block">' +
    '<defs><linearGradient id="feeGrad" x1="0%" y1="0%" x2="100%" y2="100%">' +
    '<stop offset="0%" stop-color="#fff6d8"/><stop offset="45%" stop-color="#D4AF37"/><stop offset="100%" stop-color="#9c7a1f"/>' +
    '</linearGradient></defs>' +
    '<g fill="url(#feeGrad)">' +
    '<path opacity="0.55" transform="rotate(45 100 100)" d="M100,30 C107,80 120,93 170,100 C120,107 107,120 100,170 C93,120 80,107 30,100 C80,93 93,80 100,30 Z"/>' +
    '<path d="M100,0 C110,72 128,90 200,100 C128,110 110,128 100,200 C90,128 72,110 0,100 C72,90 90,72 100,0 Z"/>' +
    '</g></svg>';

  var CODES = [
    { code: 'NEMEE5-6DTS8H', pct: '10%', min: '50€ d’achat minimum' },
    { code: 'NEMEE10-MGKCQS', pct: '10%', min: '50€ d’achat minimum' }
  ];

  function afficherPopup(cadeau) {
    var overlay = document.createElement('div');
    overlay.className = 'nemee-fee-overlay';
    overlay.innerHTML =
      '<div class="nemee-fee-modal">' +
        '<button type="button" class="nemee-fee-fermer" aria-label="Fermer">&times;</button>' +
        '<div class="nemee-fee-etoile-modal">' + STAR_SVG + '</div>' +
        '<h3>Tu as trouvé l’étoile de Némée&nbsp;!</h3>' +
        '<p>Elle t’offre <strong>' + cadeau.pct + '</strong> de réduction sur ta commande' + (cadeau.min ? ' (' + cadeau.min + ')' : '') + '.</p>' +
        '<div class="nemee-fee-code">' + cadeau.code + '</div>' +
        '<button type="button" class="nemee-fee-copier">Copier le code</button>' +
        '<p class="nemee-fee-note">À utiliser au moment du paiement.</p>' +
      '</div>';
    document.body.appendChild(overlay);

    function fermer() { overlay.remove(); }
    overlay.querySelector('.nemee-fee-fermer').addEventListener('click', fermer);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) fermer();
    });

    var boutonCopier = overlay.querySelector('.nemee-fee-copier');
    boutonCopier.addEventListener('click', function () {
      var reussi = false;
      try {
        navigator.clipboard.writeText(cadeau.code);
        reussi = true;
      } catch (err) {
        reussi = false;
      }
      boutonCopier.textContent = reussi ? 'Copié !' : cadeau.code;
    });
  }

  function positionAleatoire(fee, zoneHaute) {
    var marge = 60;
    var largeurMax = Math.max(window.innerWidth - marge, marge);
    var hauteurMax = Math.max(window.innerHeight - marge, marge);
    var left = Math.floor(Math.random() * largeurMax);
    var top;
    if (zoneHaute) {
      top = Math.floor(Math.random() * 80) + 20;
    } else {
      top = Math.floor(Math.random() * hauteurMax);
    }
    fee.style.left = left + 'px';
    fee.style.top = top + 'px';
  }

  function prochainDelai() {
    return 1000 + Math.floor(Math.random() * 1200);
  }

  function creerFee() {
    var fee = document.createElement('button');
    fee.type = 'button';
    fee.className = 'nemee-fee-etoile';
    fee.setAttribute('aria-label', 'Une étoile mystique... clique pour voir !');
    fee.innerHTML = STAR_SVG;
    document.body.appendChild(fee);

    positionAleatoire(fee, true);

    var actif = true;
    function planifierDeplacement() {
      setTimeout(function () {
        if (!actif) return;
        positionAleatoire(fee, false);
        planifierDeplacement();
      }, prochainDelai());
    }
    planifierDeplacement();

    fee.addEventListener('click', function () {
      actif = false;
      var cadeau = CODES[Math.floor(Math.random() * CODES.length)];
      afficherPopup(cadeau);
      fee.remove();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var params = new URLSearchParams(window.location.search);
    var forcerTest = params.get('etoile') === 'nemeetest';

    if (forcerTest) {
      if (Math.random() < 0.1) creerFee();
      return;
    }

    var dejaDecidee;
    try { dejaDecidee = sessionStorage.getItem('nemeeFeeDecidee'); } catch (e) { dejaDecidee = null; }
    if (dejaDecidee) return;

    try { sessionStorage.setItem('nemeeFeeDecidee', '1'); } catch (e) {}

    if (Math.random() < 0.08) creerFee();
  });
})();

(function () {
  // Suit l'ouverture/fermeture du menu mobile pour mettre en pause
  // l'affichage du manege tournant pendant ce court instant (voir
  // nemee-custom.css : .nemee-menu-ouvert). Evite de faire tourner
  // l'animation 3D du manege en meme temps que l'ouverture du menu,
  // ce qui saccadait l'affichage sur telephone.
  function trouverDetailsMenu() {
    var parId = document.getElementById('Details-menu-drawer-container');
    if (parId) return parId;
    var resume = document.querySelector('summary.header__icon--menu');
    return resume ? resume.closest('details') : null;
  }

  function demarrer() {
    var detailsMenu = trouverDetailsMenu();
    if (!detailsMenu) return;

    function synchroniser() {
      document.documentElement.classList.toggle('nemee-menu-ouvert', detailsMenu.classList.contains('menu-open'));
    }

    var observateur = new MutationObserver(synchroniser);
    observateur.observe(detailsMenu, { attributes: true, attributeFilter: ['class'] });
    synchroniser();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
